import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Box,
  Paper,
  Grid,
  Button,
  Divider,
  Tabs, Tab
} from "@mui/material";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import { useNavigate } from "react-router-dom";
import { GET_ORDERS_BY_CUSTOMER } from "../../redux/apis";
import Address from "../../components/address/address";
import MyProfile from "../../components/MyProfile/MyProfile";
import OrderHistory from "../../components/OrderHistory/OrderHistory";
import PhoneIcon from '@mui/icons-material/Phone';
import FavoriteIcon from '@mui/icons-material/Favorite';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

const HEIGHT = window.innerHeight;
const WIDTH = window.innerWidth;

const ProfilePage = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  return (
    <>
      <Header />
      <Container disableGutters={false} maxWidth={false} sx={{ maxWidth: '1400px', marginTop: 15, minWidth: '1000px' }}>

        <Box sx={{ width: '100%' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="icon tabs example"
            variant="standard" centered
            sx={{
              "& .MuiTabs-indicator": { backgroundColor: "#c72a22", height: "4px" }, // Custom indicator color
              "& .MuiTab-root": {
                textTransform: "none",
                fontSize: "16px",
                fontWeight: "bold",
                color: "#555",
                "&.Mui-selected": { color: "#c72a22" }, // Active tab color
                "&:hover": { color: "#c72a22" }, // Hover effect
              },
            }}
          >

            <Tab icon={<PersonPinIcon sx={{ color: value === 0 ? "#c72a22" : 'gray' }} />} aria-label="person" label="PROFILE" />
            <Tab icon={<LocationOnIcon sx={{ color: value === 1 ? "#c72a22" : 'gray' }} />} aria-label="phone" label="ADDRESSES" />
            <Tab icon={<ShoppingCartIcon sx={{ color: value === 2 ? "#c72a22" : 'gray' }} />} aria-label="favorite" label="MY ORDERS" />
          </Tabs>
          <Box sx={{ padding: 2 }} margin={"auto"}>
            {value === 0 && <MyProfile />}
            {value === 1 && <Address showActions={true} setDeliveryAddress={""} />}
            {value === 2 && <OrderHistory />}
          </Box>
        </Box>
      </Container>
      <Footer />
    </>
  );
};

export default ProfilePage;
